import Bloc from './Bloc.js';
import Types from './Types.js';

export default class Time extends Bloc {

	constructor (src, ctx) {

		super("time", src, ctx);
		this.f = (src, ins) => [src.master.run.time];
		this.types = [];
	}
}